import { AnalysisFeatureIncludeDTO } from "@models/platform-analysis/entities/steps/feature";
import { PDFStyleConfigs } from "../../export-pdf/configs";
import { PDFTable } from "../../export-pdf/components/tables/table";
import { PDFTableRow } from "../../export-pdf/components/tables/table-row";
import { PDFTableCell } from "../../export-pdf/components/tables/table-cell";
import { Text } from "@react-pdf/renderer";
import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";
import { PDFTableBody } from "../../export-pdf/components/tables/table-body";

export const PDFFeaturesIncluded = (
  { featureIncluded }: { featureIncluded?: AnalysisFeatureIncludeDTO[] | null}
) => {
  const { typographyStyle } = useAnalysisPDFStyles();
  const tableGroupCellWidth = PDFStyleConfigs.TableGroupCellWidth;
  const tableSubGroupCellWidth = PDFStyleConfigs.TableSubGroupCellWidth
  const tableFeatureCellWidth = PDFStyleConfigs.TableWidth - (PDFStyleConfigs.TableGroupCellWidth + PDFStyleConfigs.TableSubGroupCellWidth);

  return (
    <PDFTable>
      <PDFTableRow type="HeaderSingleLine">
        <PDFTableCell width={tableGroupCellWidth}>
          <Text style={{...typographyStyle.body2, fontWeight: "bold"}}>
            Feature group
          </Text>
        </PDFTableCell>
        <PDFTableCell width={tableSubGroupCellWidth}>
          <Text style={{...typographyStyle.body2, fontWeight: "bold"}}>
            Feature sub-group
          </Text>
        </PDFTableCell>
        <PDFTableCell width={tableFeatureCellWidth}>
          <Text style={{...typographyStyle.body2, fontWeight: "bold"}}>
            Feature
          </Text>
        </PDFTableCell>
      </PDFTableRow>
      <PDFTableBody>
        {
          featureIncluded?.map((row, index) => {
            return (
              <PDFTableRow key={index}>
                <PDFTableCell
                  width={tableGroupCellWidth}
                  alignItems="flex-start"
                >
                  <Text
                    style={{...typographyStyle.body2}}
                  >
                    { row.sectionName }
                  </Text>
                </PDFTableCell>
                <PDFTableCell
                  width={tableSubGroupCellWidth}
                  alignItems="flex-start"
                >
                  <Text
                    style={{...typographyStyle.body2}}
                  >
                    { row.subSectionName }
                  </Text>
                </PDFTableCell>
                <PDFTableCell
                  width={tableFeatureCellWidth}
                  alignItems="flex-start"
                >
                  <Text
                    style={{...typographyStyle.body2, lineHeight: 1.2}}
                  >
                    { row?.features?.map((feature) => feature.featureName).join(", ") }
                  </Text>
                </PDFTableCell>
              </PDFTableRow>
            );
          })
        }
      </PDFTableBody>
    </PDFTable>
  );
}